const LENIS_INSTANCE_KEY = '__lenis';
const LENIS_LOCK_COUNT_KEY = '__lenisLockCount';

export function getLenis() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window[LENIS_INSTANCE_KEY] || null;
}

export function setLenis(lenis) {
  if (typeof window === 'undefined') {
    return;
  }

  window[LENIS_INSTANCE_KEY] = lenis;
}

export function clearLenis(lenis) {
  if (typeof window === 'undefined') {
    return;
  }

  if (window[LENIS_INSTANCE_KEY] === lenis) {
    delete window[LENIS_INSTANCE_KEY];
  }

  delete window[LENIS_LOCK_COUNT_KEY];
}

export function lockLenis() {
  const lenis = getLenis();

  if (!lenis) {
    return;
  }

  const currentCount = window[LENIS_LOCK_COUNT_KEY] || 0;
  window[LENIS_LOCK_COUNT_KEY] = currentCount + 1;

  if (currentCount === 0) {
    lenis.stop();
  }
}

export function unlockLenis() {
  const lenis = getLenis();

  if (!lenis) {
    return;
  }

  const currentCount = window[LENIS_LOCK_COUNT_KEY] || 0;
  const nextCount = Math.max(currentCount - 1, 0);

  if (nextCount === 0) {
    delete window[LENIS_LOCK_COUNT_KEY];
    lenis.start();
    return;
  }

  window[LENIS_LOCK_COUNT_KEY] = nextCount;
}
